import { UserActivityLogType } from '../apollo/__generated__/graphql';

export const renamedLogTypes: Partial<Record<UserActivityLogType, string>> = {
  [UserActivityLogType.CreateEntity]: 'Created',
  [UserActivityLogType.UpdateEntity]: 'Updated',
  [UserActivityLogType.DeleteEntity]: 'Deleted',
  [UserActivityLogType.DuplicatedEntity]: 'Duplicated',
  [UserActivityLogType.AttemptStats]: 'Completed',
  [UserActivityLogType.UserRegistered]: 'Registered',
  [UserActivityLogType.UserLogged]: 'Login',
  [UserActivityLogType.ExportPdf]: 'Export PDF',
  [UserActivityLogType.ExportXlsx]: 'Export XLSX',
  [UserActivityLogType.DataUpload]: 'Data Upload',
};
